import React from "react";
import { Link } from "react-router-dom";

const cards = [
  {
    id: "restoran",
    to: "/restoran",
    title: "Restoran",
    description:
      "Očekuje vas autentična ponuda domaće kuhinje, pripremljene sa posebnom pažnjom i u duhu srpske tradicije.",
    features: [
      "Domaćinska atmosfera",
      "Spoj masiv drveta, kovanog gvožđa i cigle.",
      "Dnevni meni i specijaliteti kuće"
    ],
    cta: "Meni i cenovnik"
  },
  {
    id: "banket",
    to: "/banket-sala",
    title: "Banket sala",
    description:
      "Prepustite organizaciju nama i uživajte u svakom trenutku vaše proslave.",
    features: [
      "Do 190 zvanica",
      "180 parking mesta",
      "Vi slavite – mi se brinemo o svemu."
    ],
    cta: "Organizuj proslavu"
  },
  {
    id: "smestaj",
    to: "/smestaj",
    title: "Smeštaj",
    description:
      "Prenoćište nudi smeštaj od 27 ležaja raspoređenih u vidu dvokrevetnih, trokrevetnih soba i jednog trosobnog apartmana namenjenog za 5 osoba.",
    features: ["Besplatan parking"],
    cta: "Rezerviši noćenje"
  }
];

export function HighlightSections() {
  const handleClick = (id) => {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="section highlight">
      <div className="section-inner">
        <header className="section-header">
          <p className="section-eyebrow">Šta nudimo</p>
          <h2 className="section-title">
            Sve na jednom mestu –{" "}
            <span className="section-title-highlight">restoran, sala i smeštaj</span>
          </h2>
          <p className="section-subtitle">
            Kombinujemo toplinu tradicionalne srpske krčme sa udobnošću modernog
            objekta. Bilo da dolazite na ručak ili slavite najvažnije trenutke,
            mi se staramo o svakom detalju.
          </p>
        </header>
        <div className="highlight-grid">
          {cards.map((card) => (
            <article key={card.id} className="highlight-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <ul>
                {card.features.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              {card.to ? (
                <Link to={card.to} className="card-cta">
                  {card.cta}
                </Link>
              ) : (
                <button
                  type="button"
                  className="card-cta"
                  onClick={() => handleClick(card.id)}
                >
                  {card.cta}
                </button>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

